import Icons from './Icons';
import Pagination from './Pagination';

const Display = {
    Icons,
    Pagination
};

export default Display;
